// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

.asset-panel_wrapper_SgB4E {
    display: flex;
    flex-grow: 1;
    border: 1px solid var(--ui-black-transparent);
    background: var(--assets-background);
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 0.85rem;
}

[dir="ltr"] .asset-panel_wrapper_SgB4E {
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
}

[dir="rtl"] .asset-panel_wrapper_SgB4E {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
}

.asset-panel_detail-area_qwP4r {
    display: flex;
    flex-grow: 1;
    flex-shrink: 1;
    overflow: visible;
}

[dir="ltr"] .asset-panel_detail-area_qwP4r {
    border-left: 1px solid var(--ui-black-transparent);
}

[dir="rtl"] .asset-panel_detail-area_qwP4r {
    border-right: 1px solid var(--ui-black-transparent);
}
`, "",{"version":3,"sources":["webpack://./src/components/asset-panel/asset-panel.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C;IACI,aAAa;IACb,YAAY;IACZ,6CAA6C;IAC7C,oCAAoC;IACpC,2DAA2D;IAC3D,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,mDAAmD;AACvD","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n.wrapper {\n    display: flex;\n    flex-grow: 1;\n    border: 1px solid var(--ui-black-transparent);\n    background: var(--assets-background);\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    font-size: 0.85rem;\n}\n\n[dir=\"ltr\"] .wrapper {\n    border-top-right-radius: 0.5rem;\n    border-bottom-right-radius: 0.5rem;\n}\n\n[dir=\"rtl\"] .wrapper {\n    border-top-left-radius: 0.5rem;\n    border-bottom-left-radius: 0.5rem;\n}\n\n.detail-area {\n    display: flex;\n    flex-grow: 1;\n    flex-shrink: 1;\n    overflow: visible;\n}\n\n[dir=\"ltr\"] .detail-area {\n    border-left: 1px solid var(--ui-black-transparent);\n}\n\n[dir=\"rtl\"] .detail-area {\n    border-right: 1px solid var(--ui-black-transparent);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `asset-panel_wrapper_SgB4E`,
	"detail-area": `asset-panel_detail-area_qwP4r`,
	"detailArea": `asset-panel_detail-area_qwP4r`
};
export default ___CSS_LOADER_EXPORT___;
